{
  "notifications": {
    "title": "Benachrichtigungen",
    "markAllRead": "Alle als gelesen markieren",
    "viewAll": "Alle Benachrichtigungen anzeigen",
    "empty": "Keine Benachrichtigungen",
    "emptyDescription": "Sie sind auf dem neuesten Stand!",
    "new": "neu",
    "today": "Heute",
    "yesterday": "Gestern",
    "earlier": "Früher",
    "justNow": "Gerade eben",
    "minutesAgo": "Vor {{count}} Minute",
    "minutesAgo_plural": "Vor {{count}} Minuten",
    "hoursAgo": "Vor {{count}} Stunde",
    "hoursAgo_plural": "Vor {{count}} Stunden",
    "daysAgo": "Vor {{count}} Tag",
    "daysAgo_plural": "Vor {{count}} Tagen",
    "categories": {
      "status_change": "Statusaktualisierung",
      "correspondence": "Korrespondenz",
      "deadline": "Frist",
      "approval_needed": "Genehmigung erforderlich",
      "filing_complete": "Einreichung abgeschlossen",
      "new_filing": "Neue Einreichung",
      "office_action": "Amtsbescheid",
      "system": "System"
    },
    "urgency": {
      "low": "Niedrig",
      "medium": "Mittel",
      "high": "Hoch",
      "critical": "Kritisch"
    },
    "actions": {
      "view": "Ansehen",
      "dismiss": "Verwerfen",
      "markRead": "Als gelesen markieren"
    }
  }
}
